import { HStack, Text } from "@chakra-ui/react"
import { useTranslate } from "@pathwright/ui/src/components/lng/withTranslate"
import Tooltip from "@pathwright/ux/src/components/tooltip/Tooltip"
import { capitalCase } from "change-case"
import { getSchoolMembershipRoleLabel } from "../membership/constants"
import Pathicon from "../pathicon/Pathicon"
import { usePathwrightContext } from "../pathwright/PathwrightContext"

type SchoolMembershipRoleBadgeProps = {
  role: number
}

function SchoolMembershipRoleBadge({ role }: SchoolMembershipRoleBadgeProps) {
  const { t } = useTranslate()
  const { school } = usePathwrightContext()
  const roleLabel = capitalCase(getSchoolMembershipRoleLabel(role, t))
  const tip = `${school.name} ${roleLabel}`

  return (
    <Tooltip title={tip} fitContent>
      <HStack
        className="SchoolMembershipRoleBadge"
        align="center"
        borderRadius="12px"
        position="relative"
        color="brand.500"
        spacing={1}
      >
        <Pathicon icon="seal-check" />
        <Text as="span" color="inherit">
          {roleLabel}
        </Text>
      </HStack>
    </Tooltip>
  )
}

export default SchoolMembershipRoleBadge
